// @flow

import type { Event } from "@kiwicom/nitro/lib/records/Event"

export const AUTH_MAGIC_LINK_USED: Event = {
  category: "Auth",
  subCategory: "MagicLogin",
  action: "MagicLinkUsedForAuth",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true },
}

export const AUTH_MAGIC_LINK_FAILED: Event = {
  category: "Auth",
  subCategory: "MagicLogin",
  action: "AuthWithMagicLinkFailed",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true },
}

export const AUTH_MAGIC_EXPIRED__BANNER_SHOWN: Event = {
  category: "Auth",
  subCategory: "MagicLogin",
  action: "AuthMagicExpiredBannerShown",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true },
}
